import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { PackageBuilderPackage } from 'app/core/models/package-builder-package';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Constants, HTTPStatusCode } from '../core/Constants';
import { API_CMS_ENDPOINT, API_ENDPOINT } from '../core/DI';
import { LastSubject } from '../core/LastSubject';
import { CategoryFiltersRequestDto, SingleGenericStringValueIdCategoryFilter } from '../core/models/filter-backend';
import { KitComponentsDtoResponse } from '../core/models/kit-components.dto-response';

import { GenericCardAndFiltersDtoResponse } from '../core/models/generic-card-and-filter.dto-response';
import { MakeYearModel, SimpleMakeYearModel } from '../core/models/make-year-model.model';
import { PackageBuilderModel } from '../core/models/package-builder.model';
import { ProductDetailsDtoResponse } from '../core/models/product-details.dto-response';
import { ProductSpecsOptions } from '../core/models/product-specs-options.model';
import { Product } from '../core/models/product.model';
import { StaggeredPackageBuilderModel } from '../core/models/staggered-package-builder.model';
import { StaggeredProductDetailsDtoResponse } from '../core/models/staggered-product-details.dto-response';
import { TireCategoryFilter } from '../core/models/tire-category-filter.model';
import { FilterService } from '../shared/filter.service';
import { IProductService } from '../shared/iproduct.service';
import { PagingService } from '../shared/paging.service';
import { Helper } from './helper';
import { OETireSizeFitmentDtoResponse } from '../core/models/oe-tire-size-fitment.dto-response';
import { GenericSummaryCardDtoResponse } from 'app/core/models/generic-summary-card.dto-response';
import { PlacardToolKitsDtoResponse, PlacardToolKitVehiclesDtoResponse, PlacardToolPSIsDtoResponse } from 'app/core/models/placard-tool.dto-response';
import { CustomerFeedbackOption } from "app/core/models/customer-feedback-option";

@Injectable()
export class TireService implements IProductService {
  private tiresSubject = new LastSubject<GenericCardAndFiltersDtoResponse>();
  private searchWithFilterInProgress = new Subject<boolean>();
  private lastStaggerType: string = null;
  private lastShowList: string = null;
  private lastFrontWheelId: string = null;
  private lastRearWheelId: string = null;
  private lastFrontOffset?: number = null;
  private lastRearOffset?: number = null;
  private lastDesignation: string = null;
 // djb:yagni-declared but not used
  private lastSearchWithoutFilterResponse: GenericCardAndFiltersDtoResponse;
  private searchParams: MakeYearModel;
  private requestFilters: CategoryFiltersRequestDto;
  private tireBySpecsSearchParams: TireCategoryFilter;

  customParameter: {} = null;

  constructor(@Inject(API_ENDPOINT) private apiEndpoint: string,
    @Inject(API_CMS_ENDPOINT) private apiCmsEndpoint: string,
    private http: HttpClient,
    private pagingService: PagingService,
    private filterService: FilterService) {
    this.apiEndpoint = apiEndpoint;
    this.apiCmsEndpoint = apiCmsEndpoint;
  }

    get onSearchWithFilter(): Observable<boolean> {
        return this.searchWithFilterInProgress.asObservable();
    }

    searchWithTextAndFilter(searchText: string, filters: CategoryFiltersRequestDto): void {
        throw new Error('NotSupportedException');
    }

    getProductDetailsByVehicleAndFilterAndStyleAndFinish(carDetails: MakeYearModel, wheelStagger: string, filters: CategoryFiltersRequestDto)
        : Observable<Array<GenericSummaryCardDtoResponse>> {
        throw new Error('NotSupportedException');
    }

  postProductToCart(id: string, qty: number, warningNotes: string[], pairNo: string, productType: string) {
    let api = `${this.apiCmsEndpoint}/cart/AddProduct`;
    const product: Product = new Product({
      id: id,
      quantity: qty,
      warningNotes: warningNotes,
      type: Constants.PRODUCT_TYPE_TIRE,
      pairNo: pairNo
    });

        // VOLUME DISCOUNT
        if (this.customParameter !== null && this.customParameter['volumeDiscount'] !== null) {
            product.volumeDiscount = this.customParameter['volumeDiscount'];
            product.isVolumeDiscountEligible = true;
        }

    // WIP - SEASONAL CARE PLAN
    if (this.customParameter !== null && this.customParameter['scpReplaceCartContent'] !== null) {
        const _scpReplaceCartContent = this.customParameter['scpReplaceCartContent'];
        if (_scpReplaceCartContent)
            api = `${this.apiCmsEndpoint}/cart/AddProduct?scpReplaceCartContent=true`;
    }

    this.http.post(api, product).toPromise().then(response => {
      window.location.href = Constants.SHOPPING_CART_HREF;
    }).catch((err: any) => {
      window.location.href = Constants.SHOPPING_CART_HREF;
    });
  }

    postProductPairToCart(frontId: string, frontQty: number, frontWarningNotes: string[], rearId: string, rearQty: number, rearWarningNotes: string[], pairNo: string, productType: string) {
        const api = `${this.apiCmsEndpoint}/cart/AddProduct`;
        const frontProduct: Product = new Product({
            id: frontId,
            quantity: frontQty,
            warningNotes: frontWarningNotes,
            type: Constants.PRODUCT_TYPE_TIRE,
            pairNo: pairNo
        });
        const rearProduct: Product = new Product({
            id: rearId,
            quantity: rearQty,
            warningNotes: rearWarningNotes,
            type: Constants.PRODUCT_TYPE_TIRE,
            pairNo: pairNo
        });
        this.http.post(api, frontProduct).toPromise().then(frontResponse => {
            this.http.post(api, rearProduct).toPromise().then(rearResponse => {
                window.location.href = Constants.SHOPPING_CART_HREF;
            }).catch((rearErr: any) => {
                window.location.href = Constants.SHOPPING_CART_HREF;
            });
        }).catch((frontErr: any) => {
            window.location.href = Constants.SHOPPING_CART_HREF;
        });
    }

  postProductsToCart(frontProduct: Product, rearProduct: Product, frontLabours: Product[], rearLabours: Product[], car: MakeYearModel) {
    let api = `${this.apiCmsEndpoint}/cart/AddPackage`;
    const packageBuilderPackage: PackageBuilderPackage = new PackageBuilderPackage();
    packageBuilderPackage.makeYearModel = car;
    packageBuilderPackage.package = new StaggeredPackageBuilderModel();
    packageBuilderPackage.package.front = new PackageBuilderModel({
      tire: frontProduct,
      labours: frontLabours
    });
    packageBuilderPackage.package.rear = new PackageBuilderModel({
      tire: rearProduct,
      labours: rearLabours
    });

    // WIP - SEASONAL CARE PLAN
    if (this.customParameter !== null && this.customParameter['scpReplaceCartContent'] !== null) {
        const _scpReplaceCartContent = this.customParameter['scpReplaceCartContent'];
        if (_scpReplaceCartContent)
            api = `${this.apiCmsEndpoint}/cart/AddPackage?scpReplaceCartContent=true`;
    }

    this.http.post(api, packageBuilderPackage).toPromise().then(response => {
      window.location.href = Constants.SHOPPING_CART_HREF;
    }).catch((err: any) => {
      window.location.href = Constants.SHOPPING_CART_HREF;
    });
  }

    postToCartWithCar(frontId: string, frontQty: number, rearId: string = null,
        rearQty: number = null, frontWarningNotes: string[], rearWarningNotes: string[], car: MakeYearModel, pairNo: string) {
        const rearProduct = rearId && rearQty ? this.createProduct(rearId, rearQty, rearWarningNotes, pairNo) : null;
        this.postProductsToCart(this.createProduct(frontId, frontQty, frontWarningNotes, pairNo), rearProduct, null, null, car);
    }

    getProductFilters(): Observable<ProductSpecsOptions[]> {
        const api = `${this.apiEndpoint}/tires/` +
            `filters/`;
        return this.http.get<ProductSpecsOptions[]>(api);
    }

    getProductByBrandFilters(): Observable<ProductSpecsOptions[]> {
        const api = `${this.apiEndpoint}/tires/` +
            `filtersbybrand/`;
        return this.http.get<ProductSpecsOptions[]>(api);
    }


    populateProductByBrandFilters(selectedBrand, selectedModel, selectedCategory, selectedType): Promise<ProductSpecsOptions[]> {
        var query = new URLSearchParams();
        var api = `${this.apiEndpoint}/tires`;
        api += `/filtersbybrand/`;
        if (selectedBrand != "") {
            query.append("brands", selectedBrand);
        }
        if (selectedModel != "") {
            query.append("models", selectedModel);
        }
        if (selectedCategory != "") {
            query.append("categories", selectedCategory);
        }
        if (selectedType != "") {
            query.append("tiretypes", selectedType);
        }
        api += "?" + query;
        return this.http.get<ProductSpecsOptions[]>(api).toPromise();
    }


    getProductsByVehicleAndFilter(searchParams: SimpleMakeYearModel,
        filters: CategoryFiltersRequestDto, loadSecondaryFilters: boolean): void {
        if (Helper.isProductTypePreferenceTire()) {

            const p: string = sessionStorage.getItem(`TiresPaging`);
            if (p != null) {
                filters.paging.page = JSON.parse(p)["page"];
                filters.paging.pageSize = JSON.parse(p)["pageSize"];
                filters.paging.orderBy = JSON.parse(p)["orderBy"];
            }
            // Extract the stagger selected value from the filters and remove the stagger filter from the dto
            let stagger = null;
            if ((<any>filters).tirestagger) {
                stagger = (<SingleGenericStringValueIdCategoryFilter>(<any>filters).tirestagger).value.id;
                if (this.lastStaggerType !== stagger) {
                    this.lastStaggerType = stagger;
                    loadSecondaryFilters = true;
                }
                delete (<any>filters).tirestagger;
            }
            let showList: string = null;
            if ((<any>filters).show) {
                showList = (<any>filters).show.values.map(v => v.id).join(',');
            }
            if (this.lastShowList !== showList) {
                this.lastShowList = showList;
                loadSecondaryFilters = true;
            }

            this.searchWithFilterInProgress.next(true);
            let api = `${this.apiEndpoint}/tires/ByVehicle`;
            let _searchTiresByVehicleRequestDto = {
                baseFilter: searchParams,
                secondaryFilter: filters,
                loadSecondaryFilters: loadSecondaryFilters,
                stagger: stagger
            };

            this.http.post<GenericCardAndFiltersDtoResponse>(api, _searchTiresByVehicleRequestDto, { observe: 'response', responseType: 'json' })
                .subscribe(res => {
                    let tiresAndFiltersDto: GenericCardAndFiltersDtoResponse;
                    if (res.status === HTTPStatusCode.NO_CONTENT) {
                        tiresAndFiltersDto = {
                            categoryfilters: null,
                            productSummaryCards: [],
                            itemCount: 0,
                            sortOptions: [],
                            hasMoreThanOneOEMTPMS: false,
                            boltsNutsInfos: null,
                            styleFinish: [],
                            micrositeItemCounts: [],
                            alternateHexSizeExists: false
                        };
                    } else {
                        tiresAndFiltersDto = res.body;
                    }
                    this.tiresSubject.next(tiresAndFiltersDto);
                    this.searchWithFilterInProgress.next(false);
                },
                    Helper.handleError);
        }
        else
            this.getProductsByVehicleAndFilterForWheel(searchParams, filters, loadSecondaryFilters, null, null, null, null);
    }

    getProductsByVehicleAndFilterForWheel(searchParams: SimpleMakeYearModel,
        filters: CategoryFiltersRequestDto, loadSecondaryFilters: boolean, frontWheelId: string, rearWheelId: string,
        frontWheelQty: number, rearWheelQty: number, frontOffset?: number, rearOffset?: number)
        : void {
        // Extract the stagger selected value from the filters and remove the stagger filter from the dto
        let stagger = null;
        const p: string = sessionStorage.getItem(`TiresPaging`);
        if (p != null) {
            filters.paging.page = JSON.parse(p)["page"];
            filters.paging.pageSize = JSON.parse(p)["pageSize"];
            filters.paging.orderBy = JSON.parse(p)["orderBy"];
        }
        if ((<any>filters).tirestagger) {
            stagger = (<SingleGenericStringValueIdCategoryFilter>(<any>filters).tirestagger).value.id;
            if (this.lastStaggerType !== stagger) {
                this.lastStaggerType = stagger;
                loadSecondaryFilters = true;
            }
            delete (<any>filters).tirestagger;
        }
        let showList: string = null;
        if ((<any>filters).show) {
            showList = (<any>filters).show.values.map(v => v.id).join(',');
        }
        if (this.lastShowList !== showList) {
            this.lastShowList = showList;
            loadSecondaryFilters = true;
        }

        if (this.lastFrontWheelId !== frontWheelId) {
            this.lastFrontWheelId = frontWheelId;
            loadSecondaryFilters = true;
        }

        if (this.lastRearWheelId !== rearWheelId) {
            this.lastRearWheelId = rearWheelId;
            loadSecondaryFilters = true;
        }

        if (this.lastFrontOffset !== frontOffset) {
            this.lastFrontOffset = frontOffset;
            loadSecondaryFilters = true;
        }

        if (this.lastRearOffset !== rearOffset) {
            this.lastRearOffset = rearOffset;
            loadSecondaryFilters = true;
        }

        let desgination = null;
        if ((<any>filters).designation) {
            desgination = (<any>filters).designation.values.map(v => v.id).join(',');
        }
        if (this.lastDesignation !== desgination) {
            this.lastDesignation = desgination;
            loadSecondaryFilters = true;
        }

        this.searchWithFilterInProgress.next(true);
        const api = `${this.apiEndpoint}/tires/makes/summary`;
        this.http.post<GenericCardAndFiltersDtoResponse>(api, {
            baseFilter: searchParams,
            secondaryFilter: filters,
            loadSecondaryFilters: loadSecondaryFilters,
            frontWheelId: frontWheelId,
            rearWheelId: rearWheelId,
            stagger: stagger,
            frontOffset: frontOffset,
            rearOffset: rearOffset,
            frontWheelQty: frontWheelQty,
            rearWheelQty: rearWheelQty
        }, { observe: 'response', responseType: 'json' })
            .subscribe(res => {
                let tiresAndFiltersDto: GenericCardAndFiltersDtoResponse;
                if (res.status === HTTPStatusCode.NO_CONTENT) {
                    tiresAndFiltersDto = {
                        categoryfilters: null,
                        productSummaryCards: [],
                        itemCount: 0,
                        sortOptions: [],
                        hasMoreThanOneOEMTPMS: false,
                        boltsNutsInfos: null,
                        styleFinish: [],
                        micrositeItemCounts: [],
                        alternateHexSizeExists: false
                    };
                } else {
                    tiresAndFiltersDto = res.body;
                }
                this.tiresSubject.next(tiresAndFiltersDto);
                this.searchWithFilterInProgress.next(false);
            },
                Helper.handleError);

        // djb:not sure i`s this was a debug point, but it does nothing.
        // const a = "a";
    }

    getOETireSizeFitment(searchParams: MakeYearModel, frontWheelId: string, rearWheelId: string, frontOffset: string, rearOffset: string)
        : Observable<OETireSizeFitmentDtoResponse> {
        const api = `${this.apiEndpoint}/tires/makes/validateoetiresizefitment`;
        let mym = new SimpleMakeYearModel();
        mym.make = searchParams.make;
        mym.year = searchParams.year;
        mym.model = searchParams.model;
        mym.submodel = searchParams.submodel;
        mym.option = searchParams.option;
        mym.isSummerSeason = true;

        return this.http.post<OETireSizeFitmentDtoResponse>(api, {
            baseFilter: mym,
            frontWheelId: frontWheelId,
            rearWheelId: rearWheelId,
            frontOffset: frontOffset,
            rearOffset: rearOffset
        });
    }
    getProductsByVehicleAndFilterForTire(searchParams: MakeYearModel, filters: CategoryFiltersRequestDto,
        loadSecondaryFilters: boolean, frontTireId: string, rearTireId: string, frontTireQty: number, rearTireQty: number): void {
        throw new Error('NotSupportedException');
    }
    getProductsByVehicleAndFilterForAccessory(tireCategoryFilter: TireCategoryFilter,
        filters: CategoryFiltersRequestDto, loadSecondaryFilters: boolean): void {
        throw new Error('NotSupportedException');
    }

    getProductsBySpecsAndFilter(tireCategoryFilter: TireCategoryFilter,
        filters: CategoryFiltersRequestDto, loadSecondaryFilters: boolean): void {
        const p: string = sessionStorage.getItem(`TiresPaging`);
        if (p != null) {
            filters.paging.page = JSON.parse(p)["page"];
            filters.paging.pageSize = JSON.parse(p)["pageSize"];
            filters.paging.orderBy = JSON.parse(p)["orderBy"];
        }
        let showList: string = null;
        if ((<any>filters).show) {
            showList = (<any>filters).show.values.map(v => v.id).join(',');
        }
        if (this.lastShowList !== showList) {
            this.lastShowList = showList;
            loadSecondaryFilters = true;
        }

        let desgination = null;
        if ((<any>filters).designation) {
            desgination = (<any>filters).designation.values.map(v => v.id).join(',');
        }
        if (this.lastDesignation !== desgination) {
            this.lastDesignation = desgination;
            loadSecondaryFilters = true;
        }

        this.searchWithFilterInProgress.next(true);

        let url = decodeURIComponent(window.location.href);
        const showPromotions = url.includes("/promotions");
        var api = "";
        if (showPromotions) {
            api = `${this.apiEndpoint}/tires/summary?showPromotions=true`;
        }
        else {
            api = `${this.apiEndpoint}/tires/summary`;
        }

        this.http.post<GenericCardAndFiltersDtoResponse>(api, {
            baseFilter: tireCategoryFilter,
            secondaryFilter: filters,
            loadSecondaryFilters: loadSecondaryFilters
        }, { observe: 'response', responseType: 'json' })
            .subscribe(res => {
                let tiresAndFiltersDto: GenericCardAndFiltersDtoResponse;

                if (res.status === HTTPStatusCode.NO_CONTENT) {
                    tiresAndFiltersDto = {
                        categoryfilters: null,
                        productSummaryCards: [],
                        itemCount: 0,
                        sortOptions: [],
                        hasMoreThanOneOEMTPMS: false,
                        boltsNutsInfos: null,
                        styleFinish: [],
                        micrositeItemCounts: [],
                        alternateHexSizeExists: false
                    };
                } else {
                    tiresAndFiltersDto = res.body;
                }

                this.tiresSubject.next(tiresAndFiltersDto);
                this.searchWithFilterInProgress.next(false);
            },
                Helper.handleError);
    }

    getProductDetailsBySpecs(productId: string): Observable<ProductDetailsDtoResponse> {
        const api = `${this.apiEndpoint}/tires/?id=${encodeURIComponent(productId)}`;
        return this.http.get<ProductDetailsDtoResponse>(api);
    }

    getProductDetails(productId: string, carDetails: MakeYearModel, frontWheelOrTireId: string = '', rearWheelOrTireId: string = ''): Observable<ProductDetailsDtoResponse> {
        let api = `${this.apiEndpoint}/tires/` +
            `makes/${Helper.encodeURIComponent2(carDetails.make)}/` +
            `years/${Helper.encodeURIComponent2(carDetails.getYearStr)}/` +
            `models/${Helper.encodeURIComponent2(carDetails.model)}/` +
            `submodels/${Helper.encodeURIComponent2(carDetails.submodel)}/` +
            `options/${Helper.encodeURIComponent2(carDetails.option)}/` +
            `summer/${Helper.encodeURIComponent2((carDetails.isSummerSeason ? 1 : 0).toString())}/`;
        let tireFirst = Helper.isProductTypePreferenceTire();
        if (!tireFirst) {
            if (frontWheelOrTireId !== '' && rearWheelOrTireId !== '') {
                api += `wheels/${frontWheelOrTireId}/${rearWheelOrTireId}/`;
            } else if (frontWheelOrTireId !== '') {
                api += `wheels/${frontWheelOrTireId}/`;
            }
        }
        api += `id/${productId}/?tireFirst=${tireFirst}`;
        return this.http.get<ProductDetailsDtoResponse>(api);
    }

    getStaggeredProductDetails(productId: string, carDetails: MakeYearModel,
        frontWheelOrTireId: string = '', rearWheelOrTireId: string = ''): Observable<StaggeredProductDetailsDtoResponse> {
        let api = `${this.apiEndpoint}/tires/` +
            `makes/${Helper.encodeURIComponent2(carDetails.make)}/` +
            `years/${Helper.encodeURIComponent2(carDetails.getYearStr)}/` +
            `models/${Helper.encodeURIComponent2(carDetails.model)}/` +
            `submodels/${Helper.encodeURIComponent2(carDetails.submodel)}/` +
            `options/${Helper.encodeURIComponent2(carDetails.option)}/` +
            `summer/${Helper.encodeURIComponent2((carDetails.isSummerSeason ? 1 : 0).toString())}/`;
        let tireFirst = Helper.isProductTypePreferenceTire();
        if (!tireFirst) {
            if (frontWheelOrTireId !== '' && rearWheelOrTireId !== '') {
                api += `wheels/${frontWheelOrTireId}/${rearWheelOrTireId}/`;
            } else if (frontWheelOrTireId !== '') {
                api += `wheels/${frontWheelOrTireId}/`;
            }
        }
        api += `id/${productId}/?tireFirst=${tireFirst}`;
        return this.http.get<StaggeredProductDetailsDtoResponse>(api);
    }

    getStaggeredProductDetailsBySpecs(productId: string): Observable<StaggeredProductDetailsDtoResponse> {
        const api = `${this.apiEndpoint}/tires/?id=${encodeURIComponent(productId)}`;
        return this.http.get<StaggeredProductDetailsDtoResponse>(api);
    }

    get onProducts(): Observable<GenericCardAndFiltersDtoResponse> {
        return this.tiresSubject.asObservable();
    }

    get onComponents(): Observable<KitComponentsDtoResponse> {
        throw new Error('NotSupportedException');
    }


    getCategoryFiltersFromRoute(params: ParamMap): TireCategoryFilter {
        return Helper.extractTireCategoryFiltersFromRoute(params);
    }

    createProduct(id: string, qty: number, warningNotes: string[], pairNo: string) {
        return new Product({
            id: id,
            warningNotes: warningNotes,
            quantity: qty,
            //type: Constants.PRODUCT_TYPE_WHEEL,
            type: Constants.PRODUCT_TYPE_TIRE,
            pairNo: pairNo
        });
    }

    postKitToCart(id: string, qty: number): void {
        throw new Error('NotSupportedException');
    }

    searchComponents(searchText: string): void {
        throw new Error('NotSupportedException');
    }

    getPlacardToolKits(kitNo: string, keyword: string): Observable<PlacardToolKitsDtoResponse> {
        let endpoint = `${this.apiEndpoint}none/`;
        if (!endpoint.toLowerCase().includes('brand'))
            endpoint = `${this.apiEndpoint}/brand/none/`;

        const api = `${endpoint}tires/placardtool/kits?kitNo=${kitNo}&keyword=${keyword}`;
        return this.http.get<PlacardToolKitsDtoResponse>(api);
    }

    getPlacardToolKitVehicles(kitNo: string): Observable<PlacardToolKitVehiclesDtoResponse> {
        let endpoint = `${this.apiEndpoint}none/`;
        if (!endpoint.toLowerCase().includes('brand'))
            endpoint = `${this.apiEndpoint}/brand/none/`;

        const api = `${endpoint}tires/placardtool/kits/${kitNo}/vehicles`;
        return this.http.get<PlacardToolKitVehiclesDtoResponse>(api);
    }

    getPlacardToolPSIs(vehicleOptionID: number, tire: string, rearTire: string): Observable<PlacardToolPSIsDtoResponse> {
        let endpoint = `${this.apiEndpoint}none/`;
        if (!endpoint.toLowerCase().includes('brand'))
            endpoint = `${this.apiEndpoint}/brand/none/`;

        if (rearTire === null)
            rearTire = '';

        let api: string = `${endpoint}tires/placardtool/psi?vehicleOptionID=${vehicleOptionID}&tire=${tire}&rearTire=${rearTire}`;

        return this.http.get<PlacardToolPSIsDtoResponse>(api);
    }

    submitCustomerFeedback(params: ParamMap, comments: string, categoryId: number, departmentResponsible: string, itemNo: string, customerFeedbackOptionId: string): Promise<any> {
        const api = `${this.apiCmsEndpoint}/angular/send/customerfeedback`;
        const makeYearModel = Helper.extractMakeYearModelFromRouteParam(params);
        const data = {
            makeYearModel: makeYearModel,
            comments: comments,
            categoryId: categoryId,
            departmentResponsible: departmentResponsible,
            itemNo: itemNo,
            customerFeedbackOptionId: customerFeedbackOptionId
        };

        return this.http.post(api, data).toPromise();
    }

    getCustomerFeedbackOptions(): Observable<CustomerFeedbackOption[]> {
        const api = `${this.apiCmsEndpoint}/angular/customerfeedbackoption`;

        return this.http.get<CustomerFeedbackOption[]>(api);
    }
}
